export enum NotificationType {
  Success = "success",
  Error = "error",
  Pending = "pending",
  Warning = "warning",
  Info = "info",
}
